import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import BootstrapCollapse from 'react-bootstrap/Collapse';
import { FAIcon } from '../fa-icon/component.js';
import { pickDataAttributes } from '../../utils/pickDataAttributes.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';
var _excluded = ["children", "className", "data", "expanded", "onExpandedToggle", "title", "titleSize"];

var ExpandableContent = function ExpandableContent(_ref) {
  var children = _ref.children,
      className = _ref.className;
  _ref.data;

  var _ref$expanded = _ref.expanded,
      expanded = _ref$expanded === void 0 ? false : _ref$expanded,
      onExpandedToggle = _ref.onExpandedToggle,
      title = _ref.title,
      _ref$titleSize = _ref.titleSize,
      titleSize = _ref$titleSize === void 0 ? 'medium' : _ref$titleSize,
      additionalProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      contentExpanded = _useState2[0],
      setContentExpanded = _useState2[1];

  useEffect(function () {
    setContentExpanded(expanded);
  }, [expanded]);
  useEffect(function () {
    if (onExpandedToggle) {
      onExpandedToggle(contentExpanded);
    }
  }, [contentExpanded, onExpandedToggle]);

  var getClasses = function getClasses() {
    return _formatClassName(['expandable-content-title', "expandable-content-title-".concat(titleSize), className]);
  };

  var dataAttributes = pickDataAttributes(additionalProps, 'expandable-content');
  var titleTagOptions = {
    small: 'h5',
    medium: 'h4',
    large: 'h3'
  };
  var TitleTag = titleTagOptions[titleSize];
  return /*#__PURE__*/React.createElement("div", {
    className: "expandable-content"
  }, /*#__PURE__*/React.createElement("div", _extends({
    className: getClasses(),
    onClick: function onClick() {
      return setContentExpanded(!contentExpanded);
    }
  }, dataAttributes), /*#__PURE__*/React.createElement(TitleTag, null, title), /*#__PURE__*/React.createElement(FAIcon, {
    icon: contentExpanded ? 'angle-down' : 'angle-right',
    additionalClasses: "card-chevron"
  })), /*#__PURE__*/React.createElement(BootstrapCollapse, {
    "in": contentExpanded
  }, children));
};

ExpandableContent.displayName = "ExpandableContent";
export { ExpandableContent };